export const SINGLE_SELECT = 'single';
export const MULTIPLE_SELECT = 'multiple';
export const MULTIPLE_ALL_SELECT = 'multiple-all';
export const selectableProp = () => ({
  type: String,
  default: null,
  validator: (value) => value.match(/(single|multiple|multiple-all)/),
});

export default {
  computed: {
    isAllMultiselectable() {
      return this.sbSelectableTable.type === MULTIPLE_ALL_SELECT;
    },
    isMultiselectable() {
      return this.sbSelectableTable.type === MULTIPLE_SELECT;
    },
    isSingleSelectable() {
      return this.sbSelectableTable.type === SINGLE_SELECT;
    },
    isSelectable() {
      return this.isAllMultiselectable || this.isMultiselectable || this.isSingleSelectable;
    },
  },
};
